// extracted by mini-css-extract-plugin
export var container = "_ax-1";
export var cornerButtonContainer = "_ax-5";
export var disabled = "_ax-2";
export var fileContainer = "_ax-4";
export var hiddenInput = "_ax-3";
export var widthContainer = "_ax-0";